import Link from "@components/anti/Link"
import { useScrollAnim } from "src/hooks/hooks"

function InvestorsAreaTab({ listTab, tab }) {
  return (
    <section className="pb-3 sc-investors-area-tab">
      <div className="investor-area__tab-list-wrapper">
        <ul className="investor-area__tabs-list no-scroll-bar">
          {listTab.map((item, i) => (
            <li
              className={`investors-area__tab-item ${
                tab === item.key ? "active" : ""
              }`}
              key={`${i}-${item.key}`}
            >
              <Link
                className="investors-area-link"
                href={item.link}
                scroll={false}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default InvestorsAreaTab
